module.exports = __webpack_public_path__ + "img/sectItem_bg.c1a29aa8.png";